import type { Context } from '@nuxt/types'
import type { HTTPResponse } from '@nuxtjs/auth-next'

const handleAuth: (ctx: Context) => Promise<void | HTTPResponse> = async ({
  $auth,
  route,
  store,
  $platform
}) => {
  if (!$auth.loggedIn && route.path === '/login') return // after login, let nuxt auth get tokens

  // if user is not logged in
  if (!$auth.loggedIn) {
    // if warranty page is opened from Duerr Dental warranty page,
    // automatically login
    if (route.name === 'warranty-things' && route.query?.login === 'true') {
      await $auth.login()
    }
    return
  }

  // if user is logged in, try to refresh tokens
  try {
    const response = await $auth.refreshTokens()

    // redirect if refresh token not found
    if (!response) {
      // redirect without router only on website, otherwise app will have issues
      // noRouter is only needed as a workaround on website to handle invalid routes, eg: `/thing`
      const noRouter = !$platform.isNative
      $auth.redirect('login', noRouter)
      return
    }
  } catch (e) {
    // if refresh failed, log user out
    return store.dispatch('user/logout')
  }

  // load user data
  if ($auth.loggedIn) await store.dispatch('user/loadSources')
}

export default handleAuth
